import {
  DELETE_ORGANIZATION_AREAFENCE_STATUS,
  GET_AREAFENCE_DATA,
  GET_ASSET_GROUP_DROPDOWN,
  GET_DAILY_REPORTS,
  GET_SCHOOL_ALERT_REPORTS,
  GET_SCHOOL_AREAFENCE_REPORTS,
  GET_SCHOOL_OVERSPEED_REPORTS,
  // EXPORT_STOPPAGE_REPORTS,
  GET_STOPPAGE_REPORTS,
  GET_TRIP_CONFIG_VEHICLE_ASSOC_DETAILS,
  GET_TRIP_CONFIGURATION,
  GET_TRIP_REPORTS,
  GET_TRIP_RULES,
  GET_TRIP_TYPES,
  GET_USER_DROPDOWN,
  GET_VEHICLE_DROPDOWN,
  PANIC_HISTORY_REPORT,
  SET_ORGANIZATION_AREAFENCE,
  SET_TRIP_CONFIG_VEHICLE_ASSOC,
  SET_TRIP_CONFIGURATION,
  SET_TRIP_RULE,
  UPDATE_TRIP_CONFIG_VEHICLE_ASSOC_STATUS,
  UPDATE_TRIP_CONFIGURATION_STATUS,
  UPDATE_TRIP_RULE_STATUS,
} from "../actions/schoolPanelType";

const initialState = {
  getStoppageReports: [],
  getAssetGroups: [],
  getVehicles: [],
  getDailyReports: [],
  getTripReports: [],
  getSchoolAlertReports: [],
  getSchoolAreafenceReports: [],
  getSchoolOverspeedReports: [],
  getUser: [],
  getPanicHistoryReport: [],
  getOrganizationAreafenceData: [],
  updateOrganizationAreafence: [],
  deleteOrganizationAreafence: [],
  getTripConfigurationData: [],
  getTripConfigStatus: [],
  setTripConfiguration: [],
  getTripRulesData: [],
  setTripRule: [],
  updateTripRuleStatus: [],
  getTripTypesData: [],
  getTripConfigVehiclesData: [],
  setTripConfigVehicle: [],
  updateTripConfigVehicleStatus: [],
};
const getStoppageReportsReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_STOPPAGE_REPORTS:
      return {
        ...state,
        getStoppageReports: payload,
      };
    default:
      return state;
  }
};
const getVehicleDropdownReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_VEHICLE_DROPDOWN:
      return {
        ...state,
        getVehicles: payload,
      };
    default:
      return state;
  }
};
const getAssetGroupDropdownReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_ASSET_GROUP_DROPDOWN:
      return {
        ...state,
        getAssetGroups: payload,
      };
    default:
      return state;
  }
};
const getDailyReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_DAILY_REPORTS:
      return {
        ...state,
        getDailyReports: payload,
      };
    default:
      return state;
  }
};
const getTripReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TRIP_REPORTS:
      return {
        ...state,
        getTripReports: payload,
      };
    default:
      return state;
  }
};
const getSchoolAlertReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SCHOOL_ALERT_REPORTS:
      return {
        ...state,
        getSchoolAlertReports: payload,
      };
    default:
      return state;
  }
};
const getSchoolAreafenceReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SCHOOL_AREAFENCE_REPORTS:
      return {
        ...state,
        getSchoolAreafenceReports: payload,
      };
    default:
      return state;
  }
};
const getSchoolOverspeedReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_SCHOOL_OVERSPEED_REPORTS:
      return {
        ...state,
        getSchoolOverspeedReports: payload,
      };
    default:
      return state;
  }
};
const getUserByAccountIdDropdownReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_USER_DROPDOWN:
      return {
        ...state,
        getUser: payload,
      };
    default:
      return state;
  }
};
const getPanicHistoryReportReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case PANIC_HISTORY_REPORT:
      return {
        ...state,
        getPanicHistoryReport: payload,
      };
    default:
      return state;
  }
};
const getOrganizationAreafenceReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_AREAFENCE_DATA:
      return {
        ...state,
        getOrganizationAreafenceData: payload,
      };
    case SET_ORGANIZATION_AREAFENCE:
      return {
        ...state,
        updateOrganizationAreafence: payload,
      };
    case DELETE_ORGANIZATION_AREAFENCE_STATUS:
      return {
        ...state,
        deleteOrganizationAreafence: payload,
      };
    default:
      return state;
  }
};
const tripConfigurationReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TRIP_CONFIGURATION:
      return {
        ...state,
        getTripConfigurationData: payload,
      };
    case SET_TRIP_CONFIGURATION:
      return {
        ...state,
        setTripConfiguration: payload,
      };
    case UPDATE_TRIP_CONFIGURATION_STATUS:
      return {
        ...state,
        getTripConfigStatus: payload,
      };
    default:
      return state;
  }
};
const tripRulesReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TRIP_RULES:
      return {
        ...state,
        getTripRulesData: payload,
      };
    case SET_TRIP_RULE:
      return {
        ...state,
        setTripRule: payload,
      };
    case UPDATE_TRIP_RULE_STATUS:
      return {
        ...state,
        updateTripRuleStatus: payload,
      };
    case GET_TRIP_TYPES:
      return {
        ...state,
        getTripTypesData: payload,
      };
    default:
      return state;
  }
};
const tripConfigVehicleAssocReducer = (state = initialState, action) => {
  const { type, payload } = action;
  // console.log("payload", payload);
  switch (type) {
    case GET_TRIP_CONFIG_VEHICLE_ASSOC_DETAILS:
      return {
        ...state,
        getTripConfigVehiclesData: payload,
      };
    case SET_TRIP_CONFIG_VEHICLE_ASSOC:
      return {
        ...state,
        setTripConfigVehicle: payload,
      };
    case UPDATE_TRIP_CONFIG_VEHICLE_ASSOC_STATUS:
      return {
        ...state,
        updateTripConfigVehiclesStatus: payload,
      };
    default:
      return state;
  }
};

export {
  getStoppageReportsReducer,
  getVehicleDropdownReducer,
  getAssetGroupDropdownReducer,
  getDailyReportReducer,
  getTripReportReducer,
  getSchoolAlertReportReducer,
  getSchoolAreafenceReportReducer,
  getSchoolOverspeedReportReducer,
  getUserByAccountIdDropdownReducer,
  getPanicHistoryReportReducer,
  getOrganizationAreafenceReducer,
  tripConfigurationReducer,
  tripRulesReducer,
  tripConfigVehicleAssocReducer,
};
